 
  export function importScript (baseurl,success, error) {   
    var url = window.location.href; 
    let urlStr = url.split('?')[1]
    var urlSearchParams = new URLSearchParams(urlStr)
    var result = Object.fromEntries(urlSearchParams.entries())
    console.log(result)
 
    var lang = result && (result.Lang || result.lang) ? (result.Lang ? result.Lang : result.lang) : "en";
    var jsUrl = baseurl + "/TranslateSystem/handler/" + lang +".js";
      
    var oS = document.createElement('script'); 
    console.log(jsUrl)
    oS.src = jsUrl;
    document.getElementsByTagName('head')[0].appendChild(oS)
    oS.onload = function () {
        console.log("翻译器引入成功")
        success && success()
    }
    
    oS.onerror = function () {
        console.log("翻译组件引入失败") 
        error && error()
    }
} 


// WEBPACK FOOTER //
// ./src/util/importScript.js